"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ContentCard, type ImageComponent } from "fansunited-sports-ui";
import { FillImage } from "@/components/ui/FillImage";
import { MediaVariantsProvider } from "@/components/ui/MediaVariantsProvider";
import { getPostImageUrl } from "@/components/ui/PostImage";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import type { Post } from "@/payload-types";
export interface ArticleHeroProps {
  /** Featured article for the hero */
  article: Post;
  /** Hero image is the page's LCP candidate: eager load + `fetchpriority="high"`. Only the first hero on a page. */
  priority?: boolean;
}

/**
 * ArticleHero - Full-width hero section with large image and headline overlay.
 * Shows a featured article with a large background image and title overlay at the bottom.
 */
export const ArticleHero: React.FC<ArticleHeroProps> = t0 => {
  const $ = _c(22);
  const {
    article,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  const nav = useNavigation();
  const t2 = article.heroImage;
  const t3 = String(article.id);
  const t4 = article.type === "video" ? "video" : "article";
  let t5;
  if ($[0] !== article || $[1] !== nav) {
    t5 = nav.post(article);
    $[0] = article;
    $[1] = nav;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = article.title;
  const t7 = article.summary || undefined;
  let t8;
  if ($[3] !== article) {
    t8 = getPostImageUrl(article, "xlarge");
    $[3] = article;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== article.title || $[6] !== t8) {
    t9 = {
      url: t8,
      alt: article.title
    };
    $[5] = article.title;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== article.title || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t7 || $[13] !== t9) {
    t10 = {
      id: t3,
      type: t4,
      link: t5,
      title: t6,
      description: t7,
      image: t9,
      gradient: "linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.6) 25%, transparent 50%)"
    };
    $[8] = article.title;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      shadow: "none",
      borderRadius: "lg",
      borderWidth: "0",
      mainIconSize: "lg",
      typography: {
        title: "text-1xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2!",
        description: "text-sm sm:text-base text-white/80 line-clamp-2 !hidden md:!block"
      }
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <ContentCard content={t10} variant="hero" ImageComponent={FillImage as ImageComponent} styles={t11} />;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== article.heroImage || $[19] !== priority || $[20] !== t12) {
    t13 = <section className="w-full"><MediaVariantsProvider media={t2} sizes="100vw" priority={priority}>{t12}</MediaVariantsProvider></section>;
    $[18] = article.heroImage;
    $[19] = priority;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};